//////////////////////////////////////////////////////////////////////
//
//  09/26/18
//  src/store/reducers/error.js
//
//  This file contains the 'error' reducer.
//

import { ERROR_ADD, ERROR_REMOVE } from "../actionTypes";

//
//  Note: In Redux, all reducers get called regardless of the action,
//  so inside each one you have to return the original 'state' if the
//  action is not applicable.
//
export default ( state = { message : null }, action ) => {
  switch( action.type ) {
  case ERROR_ADD:     return { ...state, message : action.error };
  case ERROR_REMOVE:  return { ...state, message : null };
  default:            return state;
  }
};




// WEBPACK FOOTER //
// ./src/store/reducers/errors.js